import type { FieldMiddleware, MiddlewareContext, NextFn } from '@nestjs/graphql';
import { capitalize, isNil } from 'lodash';

import { toGlobalId } from '../node';

/**
 * Http request header name used for disable global ID
 */
export const DISABLE_GLOBAL_ID_HEADER = 'disable-global-id';

/**
 * GraphQL Field GlobalID Middlware
 * Convert local ID to global ID
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const globalIDMiddleware: FieldMiddleware = async (ctx: MiddlewareContext<any, any>, next: NextFn) => {
  const value = await next();
  /**
   * Disable transform to global ID when header was set
   */
  if (
    ctx.context?.req?.headers?.[DISABLE_GLOBAL_ID_HEADER] ||
    ctx.context?.connection?.context?.[DISABLE_GLOBAL_ID_HEADER] ||
    ctx.context?.req?.[DISABLE_GLOBAL_ID_HEADER]
  ) {
    return value;
  }

  /**
   * If value is null or undefined, return the value directly without converting it
   */
  if (isNil(value)) {
    return value;
  }

  const fieldName = ctx.info.fieldName;

  const field = ctx.info.parentType.getFields()[fieldName];

  if (fieldName === 'id') {
    const type = field.extensions?.idType || ctx.info.path.typename || '_Unknown';
    return toGlobalId(type as string, value);
  }

  if (String(field.type) === 'ID' || String(field.type) === 'ID!') {
    if (field.extensions?.idType) {
      return toGlobalId(field.extensions.idType as string, value);
    }

    /**
     * Relation ID field
     */
    if (fieldName.endsWith('ID')) {
      const type = capitalize(fieldName.replace(/ID$/, ''));
      return toGlobalId(type, value);
    }
  }

  return value;
};
